import React from "react";
import { Card, Typography, Button } from "@ann/web-components";
import {
  EmptyStateWrapper,
  EmptyStateContent,
  CardWrapper,
  CTAWrapper,
  CTAButton,
  DescriptionText,
} from "./EmptyStateRoles.styled";

const EmptyStateRoles = ({ onAction }) => (
  <EmptyStateWrapper>
    <CardWrapper>
      <Card size="medium">
        <EmptyStateContent>
          <Typography category="title" size="small" weight="bold">
            {"No role yet"}
          </Typography>
          <DescriptionText category="body" size="medium" weight="regular">
            {"Create your first role to define access permissions for your users."}
          </DescriptionText>
          {onAction && (
            <CTAWrapper>
              <CTAButton>
                <Button
                  type="primary"
                  size="medium"
                  iconRight="plus"
                  label={"Create Role"}
                  onClick={onAction}
                />
              </CTAButton>
            </CTAWrapper>
          )}
        </EmptyStateContent>
      </Card>
    </CardWrapper>
  </EmptyStateWrapper>
);

export default EmptyStateRoles;

